import { Grid2 } from "@mui/material";
import { useConstructionSites } from "@utils";
import React from "react";
import { AppCustomeSelect, AppInput, AppSelect, AppTextArea } from "../Common";
import useContractors from "src/Utils/Hooks/useContractors";
import { useConstructionSelectionHistories } from "src/Utils/Hooks/useConstructionSelectionHistories";
import { useAppSelector, selectAuth } from "@redux";

interface IProps {
  values: any;
  handleChange: any;
  touched: any;
  errors: any;
  handleBlur: any;
  optionSiteConstructions: any;
  optionConstractors: any;
  setFieldValue: any;
  onChangeConstractors: any;
  listReasons: any;
  onChangeConstruction: any;
}

const OTNewHalfDay = (props: IProps) => {
  const {
    values,
    handleChange,
    touched,
    errors,
    optionSiteConstructions,
    optionConstractors,
    setFieldValue,
    onChangeConstractors,
    handleBlur,
    listReasons,
    onChangeConstruction,
  } = props;

  const auth = useAppSelector(selectAuth);
  const id = auth?.userInfo?.id;

  const [valueConstruction, setValueConstruction] = React.useState<any>(null);
  const [constructionOptions, setConstructionOptions] = React.useState<any[]>([]);

  const { constructionList, fetchConstructionList, storeConstructionSelection } = useConstructionSelectionHistories(id ?? 0);

  //稼働時間の自動計算
  React.useEffect(() => {
    const timeStringToHours = (timeStr) => {
      const [hours, minutes, seconds] = timeStr.split(":").map(Number);
      return hours + minutes / 60 + seconds / 3600;
    };

    if (!values.start_time || !values.stop_time) {
      setFieldValue("work_time", 0);
      return;
    }

    //DB登録は小数点2桁まで
    const roundToTwo = (num) => {
      return Math.round(num * 100) / 100;
    };

    const calcWorkTime = roundToTwo(timeStringToHours(values.stop_time)
      - timeStringToHours(values.start_time)
      - values.break_time);

    //稼働時間がマイナスの場合は0にする
    if (calcWorkTime < 0) {
      setFieldValue("work_time", 0);
      return;
    }

    setFieldValue("work_time", calcWorkTime);
  }, [values.start_time, values.stop_time, values.break_time]);

  //既存の履歴順現場リストと、valuesがある場合は規定の値を設定
    React.useEffect(()=>{
      if (optionSiteConstructions?.length) {
        const newConstructionOption = optionSiteConstructions.map((item) => ({
          label: item.name,
          value: item.id.toString(),
        }));
        setConstructionOptions(newConstructionOption);
  
        if (values) {
         const constructionSelected = newConstructionOption?.find(
          (item) => item.value === values?.construction.toString()
        );
        console.log(constructionSelected);
        setValueConstruction(constructionSelected);
        }
      } else {
        setConstructionOptions([]);
      }
    },[optionSiteConstructions]);
  
    //現場選択履歴が更新されるごとにリストアップデート
    React.useEffect(()=>{
      const updatedConstructionOption = constructionList.map((item) => ({
        label: item.name,
        value: item.id.toString(),
      }));
      setConstructionOptions(updatedConstructionOption);
  
    },[constructionList]);
  
  //休憩時間初期値設定
  React.useEffect(() => {
    if (values.break_time === undefined || values.break_time === null || values.break_time === "") {
    setFieldValue("break_time", "0");
  }
  },[]);

  // const listConstructionOption =
  //   optionSiteConstructions?.constructions?.length &&
  //   optionSiteConstructions?.constructions?.map((item) => {
  //     return {
  //       label: item.name,
  //       value: item.id.toString(),
  //     };
  //   });
  // const constructionSelected = listConstructionOption?.find(
  //   (item) => item.value === values?.construction.toString()
  // );
  const { updateContractorHistory } = useContractors();
  const { updateConstructionSiteHistory } = useConstructionSites();

  return (
    <div className="newOT__time">
      <Grid2 container spacing={4}>
        {/*
        <Grid2 size={{ xs: 12, md: 6 }}>
          <div className="input">
            <AppInput
              isNumber
              value={values.break_time === undefined || values.break_time === null || values.break_time === "" ? "0" : String(values.break_time)}
              handleChange={handleChange("break_time")}
              label="休憩 (hour)"
              error={errors.break_time}
              touched={touched.break_time}
            />
          </div>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <div className="input">
            <AppInput
              isNumber
              value={String(values.work_time)}
              handleChange={handleChange("work_time")}
              label="稼働時間 (hour)"
              error={errors.work_time}
              touched={touched.work_time}
              readonly
            />
          </div>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="user__department">
            <p className="label">工事名</p>
            <AppCustomeSelect
              options={constructionOptions}
              placeholder="select 請負業者"
              name="construction"
              value={valueConstruction}
              // noError={errors.constructors}
              onChange={(value) => {
                // updateConstructionSiteHistory(value);
                onChangeConstruction(value, setFieldValue);
                setValueConstruction(value);
                storeConstructionSelection({ user_id: Number(id), selected_construction_id: Number(value.value) });
              }}
              error={errors.construction}
              touched={touched.construction}
            />
          </div>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="input">
            <AppInput
              label="業務内容"
              value={values.work_detail}
              name="work_detail"
              error={errors.work_detail}
              touched={touched.work_detail}
              handleChange={handleChange("work_detail")}
            />
          </div>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="input">
            <label className="label">業者名</label>

            <div className="select__contractor">
              <div style={{ width: "70%" }}>
                <AppCustomeSelect
                  groupOptions={optionConstractors}
                  options={
                    optionConstractors?.contractors?.length &&
                    optionConstractors?.contractors.map((item) => {
                      return {
                        label: item.name,
                        value: item.id.toString(),
                      };
                    })
                  }
                  placeholder="select 請負業者"
                  name="subContractor"
                  value={values.subContractor}
                  // noError={errors.constructors}
                  onChange={(value) => {
                    updateContractorHistory(value);
                    onChangeConstractors(value, values, setFieldValue);
                    setFieldValue("subContractor", value);
                  }}
                  isMulti
                />
              </div>
            </div>
            {errors.subContractor && touched.subContractor && (
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  marginTop: "5px",
                }}
              >
                {errors?.subContractor}
              </p>
            )}
          </div>
        </Grid2>
        */}
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="des">
            <label className="label">理由</label>
            <AppSelect
              options={
                listReasons?.length &&
                listReasons?.map((item) => {
                  return {
                    label: item.name,
                    value: item.id?.toString(),
                  };
                })
              }
              name="reasonType"
              value={values.reasonType}
              handleChange={handleChange("reasonType")}
              placeholder="理由を選択してください"
              error={touched.reasonType ? errors.reasonType : undefined}
            />
          </div>
          {values.reasonType === "0" && (
            <div className="input">
              <AppInput
                value={values.reasonContent}
                name="reasonContent"
                error={errors.reasonContent}
                touched={touched.reasonContent}
                handleChange={handleChange("reasonContent")}
              />
            </div>
          )}
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="input">
            <label className="label">連絡先</label>
            <AppTextArea
              name="phoneNumber"
              handleChange={handleChange("phoneNumber")}
              value={values.phoneNumber}
              error={errors.phoneNumber}
              touched={touched.phoneNumber}
              handleBlur={handleBlur("phoneNumber")}
            // isNumber
            />
          </div>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12 }}>
          <div className="input">
            <AppInput
              label="備考"
              value={values.memo}
              name="memo"
              // error={errors.memo}
              error={touched.memo ? errors.memo : undefined}
              touched={touched.memo}
              handleChange={handleChange("memo")}
            />
          </div>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default OTNewHalfDay;
